// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1195":"84948458","7167":"2cf54083"}[chunkId] + ".chunk.css";
};